const rootUrl = process.env.REACT_APP_API ?? window.location.origin

export const client = {
  default: {
    demoAPI: rootUrl,
    clientUID: 'demoUser',
    apiName: 'API-Rows',
    apiPath: '',
  },
}
